const ACCOUNTS = `accounts`;
const ACCOUNT = `${ACCOUNTS}/:accountId`;

const PROJECTS = `${ACCOUNT}/projects`;
const PROJECT = `${PROJECTS}/:projectId`;
const PROJECT_EXPORT = `${PROJECT}/export`;
const PROJECT_IMPORT = `${PROJECTS}/import`;
const PROJECT_DUPLICATE = `${PROJECT}/duplicate`;
const PROJECT_AUDIT_LOGS = `${PROJECT}/audit`;
const PROJECT_FROM_TEMPLATE = `${PROJECTS}/from-template`;

const INTEGRATIONS = `${PROJECT}/integrations`;
const INTEGRATIONS_START_CONNECTION = `${INTEGRATIONS}/start-connection`;
const INTEGRATIONS_NICE_MESSAGING_HANDOFF_CHANNEL = `${INTEGRATIONS}/nice-messaging-handoff/channel`;
const INTEGRATIONS_NICE_MESSAGING_HANDOFF_BOX_CREDENTIALS = `${INTEGRATIONS}/nice-messaging-handoff/integration-box-credentials`;

const BRANCHES = `${PROJECT}/branches`;
const BRANCH = `${BRANCHES}/:branchId`;
const ACCOUNT_BRANCH_COUNTS = `${ACCOUNT}/branch-counts`;
const BRANCH_EVENTS = `${BRANCH}/events`;
const BRANCH_SNAPSHOT = `${BRANCH}/snapshot`;
const BRANCH_MERGE = `${BRANCH}/merge`;
const BRANCH_COMMAND_BATCH = `${BRANCH}/command-batch`;
const BRANCH_PROJECTION = `${BRANCH}/projection`;
const BRANCH_PROJECTION_SLICE = `${BRANCH}/projection/:slice`;
const BRANCH_PROJECTION_METADATA = `${BRANCH}/projection-metadata`;
const BRANCH_SEQUENCE = `${BRANCH}/sequence`;
const BRANCH_AUDIT_LOGS = `${BRANCH}/audit`;
const BRANCH_CHAT = `${BRANCH}/chat`;
const BRANCH_DEPLOY = `${BRANCH}/deploy`;
const BRANCH_TEST_FUNCTION = `${BRANCH}/functions/:functionId/test`;
const DEPLOYMENTS = `${PROJECT}/deployments`;
const DEPLOYMENT = `${DEPLOYMENTS}/:deploymentId`;
const DEPLOYMENT_ROLLBACK = `${DEPLOYMENT}/rollback`;
const DEPLOYMENT_PROJECTION = `${DEPLOYMENT}/projection`;
const DEPLOYMENT_PROJECTION_SLICE = `${DEPLOYMENT}/projection/:slice`;
const DEPLOYMENT_PROMOTE = `${DEPLOYMENT}/promote`;
const DEPLOYMENTS_INITIAL = `${DEPLOYMENTS}/initial`;

const PROMPT_EXTRACTION = `${ACCOUNT}/agent-wizard/prompts/extract`;
const CONTEXT_SEARCH = `${ACCOUNT}/context-search`;
const AGENT_CREATION = `${ACCOUNT}/agent-wizard/projects`;
const AGENT_DEEP_SEARCH = `${PROJECT}/agent-wizard/deep-search`;
const AGENT_SETUP = `${PROJECT}/agent-wizard/setup`;
const AGENT_SETUP_STATUS = `${PROJECT}/agent-wizard/setup/status`;
const AGENT_SETUP_ACTIVE_JOBS = `${ACCOUNT}/agent-wizard/setup/active`;
const AGENT_CONFIG_UPDATE = `${PROJECT}/agent-config/update`;
const TEST_EXTRACTION = `${ACCOUNT}/agent-wizard/test-extraction`;
const TRIGGER_TEST_CASE = `${PROJECT}/test-cases/:testCaseId/trigger`;
const TRIGGER_TEST_RUN = `${PROJECT}/test-runs`;
const TRIGGER_TEST_SET = `${PROJECT}/test-sets/:testSetId/trigger`;
const RERUN_TEST_RUN = `${PROJECT}/test-runs/:testRunId/rerun`;
const INTERNAL_VARIANTS = `${PROJECT}/variants`;
const INTERNAL_VARIANT = `${INTERNAL_VARIANTS}/:variantId`;

// Public API endpoints
const PUBLIC_ACCOUNT = `accounts/:accountId`;
const PUBLIC_ACCOUNT_AGENTS = `${PUBLIC_ACCOUNT}/agents`;
const PUBLIC_AGENTS = `agents`;
const PUBLIC_AGENT = `${PUBLIC_AGENTS}/:agentId`;
const PUBLIC_AGENT_DUPLICATE = `${PUBLIC_AGENT}/duplicate`;
const PUBLIC_BRANCHES = `${PUBLIC_AGENT}/branches`;
const PUBLIC_BRANCH = `${PUBLIC_AGENT}/branches/:branchId`;
const PUBLIC_BRANCH_MERGE = `${PUBLIC_AGENT}/branches/:branchId/merge`;
const PUBLIC_AGENT_BEHAVIOR = `${PUBLIC_BRANCH}/behavior`;
const PUBLIC_VARIANTS = `${PUBLIC_BRANCH}/variants`;
const PUBLIC_VARIANT = `${PUBLIC_VARIANTS}/:variantId`;
const PUBLIC_ATTRIBUTES = `${PUBLIC_BRANCH}/attributes`;
const PUBLIC_ATTRIBUTE = `${PUBLIC_ATTRIBUTES}/:attributeId`;
const PUBLIC_KNOWLEDGE_BASE_TOPICS = `${PUBLIC_BRANCH}/knowledge-base/topics`;
const PUBLIC_KNOWLEDGE_BASE_TOPIC = `${PUBLIC_KNOWLEDGE_BASE_TOPICS}/:topicId`;
const PUBLIC_KB_TOPICS_PREVIEW = `${PUBLIC_AGENT}/knowledge-base/topics/preview`;
const PUBLIC_DEPLOYMENTS = `${PUBLIC_AGENT}/deployments`;
const PUBLIC_DEPLOYMENT = `${PUBLIC_DEPLOYMENTS}/:deploymentId`;
const PUBLIC_DEPLOYMENT_PROMOTE = `${PUBLIC_DEPLOYMENT}/promote`;
const PUBLIC_DEPLOYMENT_ROLLBACK = `${PUBLIC_DEPLOYMENT}/rollback`;

const WEBRTC_CONNECTIONS = `webrtc-connections`;
const WEBRTC_CONNECTION = `${WEBRTC_CONNECTIONS}/:connectionId`;
const DELETE_WEBRTC_CONNECTION = `${WEBRTC_CONNECTIONS}/account/:accountId/project/:projectId/:clientEnv`;

const SAMPLE_PROJECTS = `sample-projects`;
const SAMPLE_PROJECT = `${SAMPLE_PROJECTS}/:projectId`;
const SAMPLE_PROJECT_PROJECTION = `${SAMPLE_PROJECT}/projection`;

// Agent Builder Conversations
const AGENT_CONVERSATIONS = `${PROJECT}/agent-builder/conversations`;
const AGENT_CONVERSATION = `${AGENT_CONVERSATIONS}/:conversationId`;

// Glot Usage
const GLOT_USAGE = `${ACCOUNT}/glot-usage`;

export const externalV1Prefix = `/api/v1`;
export const internalV1Prefix = `/internal/v1`;
export const publicV1Prefix = `/public_api/v1`;
export const adkV1Prefix = `/public_api/adk/v1`;

export const PUBLIC_ENDPOINTS = {
  PUBLIC_ACCOUNT_AGENTS,
  PUBLIC_AGENT,
  PUBLIC_AGENT_DUPLICATE,
  PUBLIC_AGENT_BEHAVIOR,
  PUBLIC_BRANCHES,
  PUBLIC_BRANCH,
  PUBLIC_BRANCH_MERGE,
  PUBLIC_VARIANTS,
  PUBLIC_VARIANT,
  PUBLIC_ATTRIBUTES,
  PUBLIC_ATTRIBUTE,
  PUBLIC_KNOWLEDGE_BASE_TOPICS,
  PUBLIC_KNOWLEDGE_BASE_TOPIC,
  PUBLIC_DEPLOYMENTS,
  PUBLIC_DEPLOYMENT,
  PUBLIC_DEPLOYMENT_PROMOTE,
  PUBLIC_DEPLOYMENT_ROLLBACK,
} as const;

export const ENDPOINTS = {
  INTEGRATIONS_START_CONNECTION,
  INTEGRATIONS_NICE_MESSAGING_HANDOFF_CHANNEL,
  INTEGRATIONS_NICE_MESSAGING_HANDOFF_BOX_CREDENTIALS,
  BRANCHES,
  BRANCH,
  ACCOUNT_BRANCH_COUNTS,
  BRANCH_EVENTS,
  BRANCH_SNAPSHOT,
  BRANCH_MERGE,
  BRANCH_COMMAND_BATCH,
  BRANCH_PROJECTION,
  BRANCH_PROJECTION_SLICE,
  BRANCH_PROJECTION_METADATA,
  BRANCH_SEQUENCE,
  BRANCH_AUDIT_LOGS,
  BRANCH_CHAT,
  BRANCH_DEPLOY,
  BRANCH_TEST_FUNCTION,
  DEPLOYMENT,
  PROJECT_AUDIT_LOGS,
  PROJECTS,
  PROJECT,
  PROJECT_DUPLICATE,
  PROJECT_IMPORT,
  PROJECT_EXPORT,
  PROJECT_FROM_TEMPLATE,
  DEPLOYMENT_ROLLBACK,
  DEPLOYMENT_PROJECTION,
  DEPLOYMENT_PROJECTION_SLICE,
  DEPLOYMENT_PROMOTE,
  DEPLOYMENTS_INITIAL,
  PROMPT_EXTRACTION,
  CONTEXT_SEARCH,
  AGENT_CREATION,
  AGENT_DEEP_SEARCH,
  AGENT_SETUP,
  AGENT_SETUP_STATUS,
  AGENT_SETUP_ACTIVE_JOBS,
  AGENT_CONFIG_UPDATE,
  TEST_EXTRACTION,
  TRIGGER_TEST_CASE,
  TRIGGER_TEST_RUN,
  TRIGGER_TEST_SET,
  RERUN_TEST_RUN,
  INTERNAL_VARIANTS,
  INTERNAL_VARIANT,
  WEBRTC_CONNECTIONS,
  WEBRTC_CONNECTION,
  DELETE_WEBRTC_CONNECTION,
  PUBLIC_KB_TOPICS_PREVIEW,
  SAMPLE_PROJECTS,
  SAMPLE_PROJECT,
  SAMPLE_PROJECT_PROJECTION,
  AGENT_CONVERSATIONS,
  AGENT_CONVERSATION,
  GLOT_USAGE,
} as const;
